/**
 * Tour step builders — nav paths and selectors derived from NAV_SECTIONS.
 * @module features/walkthrough/tours/navTourHelpers
 */

import { NAV_SECTIONS } from '../../../navigation/navConfig';

/**
 * @param {string} navItemId
 * @returns {{ section: import('../../../navigation/navConfig').NavSectionDef, item: import('../../../navigation/navConfig').NavItemDef } | null}
 */
export function findNavItem(navItemId) {
  for (const section of NAV_SECTIONS) {
    const item = section.items.find((entry) => entry.id === navItemId);
    if (item) {
      return { section, item };
    }
  }
  return null;
}

/**
 * @param {string} navItemId
 * @returns {string | null}
 */
export function navItemPath(navItemId) {
  return findNavItem(navItemId)?.item.path ?? null;
}

/**
 * @param {string} navItemId
 * @param {Object} options
 * @param {string} options.title
 * @param {string} options.body
 * @param {import('../walkthroughTypes').WalkthroughStepPlacement} [options.placement]
 * @param {string} [options.id]
 * @param {string} [options.route]
 * @returns {import('../walkthroughTypes').WalkthroughStepDef}
 */
export function navStep(navItemId, { title, body, placement = 'right', id, route }) {
  return {
    id: id ?? `nav-${navItemId}`,
    navItemId,
    route: route ?? navItemPath(navItemId) ?? undefined,
    targetSelector: `[data-walkthrough="nav-${navItemId}"]`,
    title,
    body,
    placement,
  };
}

/**
 * @param {string} id
 * @param {Object} options
 * @param {string} options.title
 * @param {string} options.body
 * @param {import('../walkthroughTypes').WalkthroughStepPlacement} [options.placement]
 * @param {string} [options.targetSelector]
 * @returns {import('../walkthroughTypes').WalkthroughStepDef}
 */
export function pageStep(id, { title, body, placement = 'bottom', targetSelector }) {
  return {
    id,
    targetSelector: targetSelector ?? `[data-walkthrough="${id}"]`,
    title,
    body,
    placement,
  };
}
